import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2uphvkwhlc: FaireBrandEntity = {
  token: "b_2uphvkwhlc",
  type: "brand",
  name: "Dress Forum",
  avatarUrl:
    "https://cdn.faire.com/fastly/1582713e83dad16947126c249dc040ca47ec82d22b4782aae764d323edcef170.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/92d0ed934afd56ae0a1c12b60a00423fc36a1a91b57154e414e3f74e53e55c99.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1582713e83dad16947126c249dc040ca47ec82d22b4782aae764d323edcef170.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/92d0ed934afd56ae0a1c12b60a00423fc36a1a91b57154e414e3f74e53e55c99.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 430,
  isInsider: true,
  description:
    "Dress Forum is a Los Angeles based fashion brand.\n\nSince the launch in 2014, we have been designing young contemporary women's clothing. We specialize in beautiful prints with a timeless color palette in soft and breezy silhouettes. \n\nOur muses are free-spirited girls with an eclectic, effortless day-to-night style. Each piece is designed with intricate detailing and understated feminine aesthetics without compromising comfort.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:08.952Z",
    importedBy: "entity-db-cli",
  },
};
